import { clsx } from 'clsx';
import { User, Settings, Tag, Building2, Wallet, Users, Shield, Database, ClipboardList } from 'lucide-react';

export type SettingsTab = 'profile' | 'security' | 'preferences' | 'categories' | 'entities' | 'accounts' | 'users' | 'data' | 'audit';

interface SettingsTabsProps {
  activeTab: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
  isAdmin: boolean;
  isSuperAdmin?: boolean;
}

const tabs: { id: SettingsTab; label: string; icon: React.ElementType; adminOnly?: boolean; superAdminOnly?: boolean }[] = [
  { id: 'profile', label: 'Profile', icon: User },
  { id: 'security', label: 'Security', icon: Shield },
  { id: 'users', label: 'Users', icon: Users, adminOnly: true },
  { id: 'preferences', label: 'Preferences', icon: Settings },
  { id: 'categories', label: 'Categories', icon: Tag },
  { id: 'entities', label: 'Entities', icon: Building2 },
  { id: 'accounts', label: 'Accounts', icon: Wallet },
  { id: 'data', label: 'Data', icon: Database, adminOnly: true },
  { id: 'audit', label: 'Audit Log', icon: ClipboardList, superAdminOnly: true },
];

export function SettingsTabs({ activeTab, onTabChange, isAdmin, isSuperAdmin }: SettingsTabsProps) {
  const visibleTabs = tabs.filter((tab) => {
    if (tab.superAdminOnly) return isSuperAdmin;
    if (tab.adminOnly) return isAdmin;
    return true;
  });

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex flex-wrap gap-x-4 gap-y-1 md:flex-nowrap md:space-x-8 md:gap-0" aria-label="Settings tabs">
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={clsx(
                'group inline-flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm',
                isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              <Icon
                className={clsx(
                  'h-5 w-5',
                  isActive ? 'text-primary-500' : 'text-gray-400 group-hover:text-gray-500'
                )}
              />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
